<template>
  <el-dialog
    title="物流轨迹"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div v-if="dataModel.shipment_type == 2 && !express_id">
      <p class="gray9">选择分包物流</p>
      <template>
        <div v-for="(item, index) in expressList" :key="index">
          <el-radio  label="item.express_id" @change="getExpressDetail(item.express_id,item.express_no,order_id)">物流名称：{{item.express.express_name}} 物流单号：{{item.express_no}}</el-radio>
        </div>
      </template>
    </div>
    <div class="p20">
        <p class="f24 mb20">{{ express.express_name }} {{ express.express_no }}</p>
        <el-timeline v-if="express.delivery_platform==0">
            <el-timeline-item
            v-for="(item, index) in express.list"
            :key="index"
            :color="index==0 ? '#1989fa' : ''"
            :timestamp="item.time">
            <el-tag :type="item.status=='在途' ? 'info' : ''">{{item.status}}</el-tag>
            {{item.context}}
            </el-timeline-item>
        </el-timeline>
        <el-timeline v-if="express.delivery_platform==10">
            <el-timeline-item
            v-for="(item, index) in express.list"
            :key="index"
            :color="index==0 ? '#1989fa' : ''"
            :timestamp="item.AcceptTime">
            {{item.AcceptStation}}
            </el-timeline-item>
        </el-timeline>
        <el-timeline v-if="express.delivery_platform==20">
            <el-timeline-item
            v-for="(item, index) in express.list"
            :key="index"
            :color="index==0 ? '#1989fa' : ''"
            :timestamp="item.time">
            【{{item.areaName}}】
            {{item.desc}}
            </el-timeline-item>
        </el-timeline>
    </div>
  </el-dialog>
</template>

<script>
import OrderApi from "@/api/order.js";
export default {
  data() {
    return {
      order_id: 0,
      express_id: 0,
      express_no: '',
      expressList: [],
      loading: false,
      /*左边长度*/
      formLabelWidth: "100px",
      /*是否显示*/
      dialogVisible: true,
      express: {
          express_name: '',
          express_no: '',
      }
    };
  },
  props: ["open_edit", "dataModel", "part_express"],
  created() {
    this.order_id = this.dataModel.order_id;
    if (this.dataModel.shipment_type == 1) {
      
      this.getData();
    } else if (this.part_express) {
      this.express_id = this.part_express.express_id ? this.part_express.express_id : 0;
      this.express_no = this.part_express.express_no ? this.part_express.express_no : '';
      this.getData();
    } else {
      this.getExpress();
    }
    
  },
  methods: {
    /*获取参数*/
    getData() {
      let self = this;
      OrderApi.getExpressTrack(
        {
          order_id: self.order_id,
          express_id: self.express_id,
          express_no: self.express_no,
        },
        true
      )
        .then((data) => {
          self.loading = false;
          self.express = data.data.express;
          console.log(self.express);
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    /*获取物流*/
    getExpress() {
      let self = this;
      OrderApi.getOrderExpress(
        {
          order_id: this.dataModel.order_id
        },
        true
      )
        .then((data) => {
          self.loading = false;
          self.expressList = data.data.list;
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    /*获取物流详情*/
    getExpressDetail(express_id,express_no) {
      this.express_id = express_id;
      this.express_no = express_no;
      this.getData();
    },
    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit("close", { openDialog: false });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/Track.vue